<style>
    ol, ul{
        margin-left: 1.25rem !important;
    }
    ol {
        list-style-type: decimal !important;
    }
    ul {
        list-style-type: disc !important;
    }
</style>

<template>
    <layout-general-container :noSideSpacer="false" spaceToolbar>
        <div class="w-full grid bg-white grid-cols-12" v-if="isProgressFinished">
            <div v-if="courseDetail" class="flex flex-col col-span-12 lg:col-span-8 xl:col-span-9 lg:pr-6 xl:pr-10 gap-6">
                <div class="h-[18rem] lg:h-[16rem] relative items-center justify-center flex w-full">
                    <img :src="courseImage" class="h-full z-0 object-cover brightness-50 absolute w-full rounded-xl"
                        alt="">
                    <div class="flex flex-col gap-5 lg:gap-4 w-full p-6" style="z-index: 1;">
                            <h1 class="text-lg lg:text-xl xl:text-2xl text-white font-medium tracking-wide">{{ courseDetail.courses.title
                        }}</h1>
                        <h2 class="text-xs text-white font-light" v-html="sanitizedDesc(courseDetail.courses.desc).slice(0, 100)"></h2>
                        <div class="flex flex-row flex-wrap items-center gap-3">
                            <div class="flex min-w-max flex-row items-center gap-2">
                                <IconClockPlay class="text-white" :size="16" />
                                <span class="text-xs text-white">{{ minuteToHour(courseDetail.total_duration) }}</span>
                            </div>
                            <span class="text-white text-sm" v-if="courseDetail?.courses?.category?.name">|</span>
                            <span class="text-xs min-w-max text-white" v-if="courseDetail?.courses?.category?.name">{{ courseDetail?.courses?.category?.name }}</span>
                            <span class="text-white text-sm">|</span>
                            <div class="flex flex-row items-center min-w-max gap-2">
                                <!-- <a-rate class="text-xs" disabled allowHalf :value="courseDetail.rating" /> -->
                                <rater-element :rating="parseFloat(courseDetail.rating)" />
                                <span class="text-xs text-white">{{ parseFloat(courseDetail.rating).toFixed(1) }}</span>
                                <span class="text-xs text-white">({{ courseDetail.total_reviews }} rating)</span>
                            </div>
                        </div>
                        <a-button @click="onEnroll" :id="'course-detail-enroll'" class="w-fit" :class="enrollDisabled ? 'bg-gray-700 text-white border-none' : ''" type="primary" :disabled="enrollDisabled">{{ enrollStatus }}</a-button>
                    </div>
                </div>
                <div class="flex flex-col gap-5">
                    <div class="flex flex-col gap-2">
                        <span class="font-semibold text-sm text-light">Description</span>
                        <span class="text-sm font-light leading-loose flex">
                            <span v-html="sanitizedDesc(courseDetail.courses.desc)"></span>
                            <!-- <span v-html="sanitizedDesc(courseDetail.courses.desc).slice(0, isExpanded ? undefined : 150)"></span> -->
                            <!-- <span
                                class="text-primary cursor-pointer font-medium"
                                @click="toggleReadMore"
                            >
                                {{ isExpanded ? 'Read Less' : 'Read More' }}
                            </span> -->
                        </span>
                    </div>
                    <div class="flex flex-col gap-3">
                        <span class="font-semibold text-sm text-light">Course Detail</span>
                        <div class="w-full grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4">
                            <div class="w-full bg-white rounded-2xl p-4 border gap-2 flex flex-col">
                                <span class="text-xs text-gray-500">Lesson</span>
                                <div class="flex flex-row items-center gap-2">
                                    <IconColorSwatch class="text-primary" :size="24" />
                                    <span class="text-base font-medium text-light">{{ courseInfo.total_lessons }}</span>
                                </div>
                            </div>
                            <div class="w-full bg-white rounded-2xl p-4 border gap-2 flex flex-col">
                                <span class="text-xs text-gray-500">Duration</span>
                                <div class="flex flex-row items-center gap-2">
                                    <IconClockPlay class="text-primary" :size="24" />
                                    <span class="text-base font-medium text-light">{{ minuteToHour(courseInfo.total_duration) }}</span>
                                </div>
                            </div>
                            <div class="w-full bg-white rounded-2xl p-4 border gap-2 flex flex-col">
                                <span class="text-xs text-gray-500">Video</span>
                                <div class="flex flex-row items-center gap-2">
                                    <IconBrandYoutube class="text-primary" :size="24" />
                                    <span class="text-base font-medium text-light">{{ courseInfo.total_video }}</span>
                                </div>
                            </div>
                            <div class="w-full bg-white rounded-2xl p-4 border gap-2 flex flex-col">
                                <span class="text-xs text-gray-500">Asssignment</span>
                                <div class="flex flex-row items-center gap-2">
                                    <IconClipboardText class="text-primary" :size="24" />
                                    <span class="text-base font-medium text-light">{{ courseInfo.total_assignment }}</span>
                                </div>
                            </div>
                            <div class="w-full bg-white rounded-2xl p-4 border gap-2 flex flex-col">
                                <span class="text-xs text-gray-500">Level</span>
                                <div class="flex flex-row items-center gap-2">
                                    <IconChartBar class="text-primary" :size="24" />
                                    <span class="text-base font-medium text-light">{{ courseInfo.level }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col w-full gap-4">
                        <span class="font-semibold text-sm text-light">Course Content</span>
                        <span class="text-xs text-gray-700">{{ courseContents.length }} sections • {{ countAllLesson() }} lessons</span>
                        <a-collapse class="bg-white" v-for="(cItem, index) in courseContents" :key="index">
                            <a-collapse-panel :header="`Section ${index + 1}: ${cItem.title}`">
                                <div class="py-4 px-6 w-full flex flex-col gap-4">
                                    <div v-for="lItem in cItem.sub_section" :key="lItem.id"
                                        class="w-full flex flex-row items-center justify-between">
                                        <div class="flex flex-row gap-4 text-gray-600">
                                            <IconVideo v-if="lItem.type === 'Video'" size="20" stroke-width="1.5" />
                                            <IconMessageQuestion v-if="lItem.type === 'Quiz'" size="20"
                                                stroke-width="1.5" />
                                            <span class="text-sm">{{ lItem.title }}</span>
                                        </div>
                                        <span class="text-sm text-primary">{{ lItem.duration }}</span>
                                    </div>
                                </div>
                                <template #extra>
                                    <span class="">{{ cItem.sub_section.length }} Lessons</span>
                                </template>
                            </a-collapse-panel>
                        </a-collapse>
                    </div>
                    <span class="font-semibold text-sm text-light">Reviews ({{ courseReviews.length }})</span>
                    <div class="w-full flex flex-col gap-3">
                        <div v-for="item in courseReviews" :key="item.id" class="border-b w-full flex flex-col gap-4 pb-6 pt-4">
                            <div class="flex flex-row gap-4 items-center">
                                <img :src="item?.startup?.photo || avatarUrl(item.startup.name)" class="h-8 w-8 rounded-full" alt="Avatar">

                                <div class="flex flex-col">
                                    <span class="text-sm font-semibold">{{ item.startup.name }}</span>
                                    <div class="flex flex-row gap-3 items-center">
                                        <!-- <a-rate class="text-sm" disabled allowHalf :value="item.star" /> -->
                                        <rater-element :rating="parseFloat(item.star)" />
                                        <span class="text-xs font-medium">{{ moment(item.created_at).fromNow() }}</span>
                                    </div>
                                </div>
                            </div>
                            <span class="text-xs">
                                {{ item.review }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col col-span-12 md:col-span-4 xl:col-span-3 gap-6">
                <span class="text-sm text-primary font-medium">Other Course</span>
                <card-course v-for="item in similarCourse" :key="item.id" :title="item.title"
                    :enrolled="item.isEnrolled" :rating="Number(item.rating)" :image="item.photo" :enroll="item.total_reviews"
                    :id="item.id" 
                    :slug="item.slug" 
                    :lesson="item?.total_lessons"
                    :completed="item?.total_completed"
                    :finished="item?.finished_percentage"
                    :speakerName="item.speaker_name"
                    :speakerPhoto="item.speaker_photo"
                    :isFree="item.program_id == null"
                 />
            </div>
        </div>
        
        <div class="w-full grid bg-white grid-cols-12 min-h-screen" v-else></div>
    </layout-general-container>
</template>

<script setup>
import axios from "@/plugins/axios";
import defaultBanner from "@/assets/img/course/banner-1.png"
import DummyCourse from '../../assets/Dummy/course.js';
import { ref, onMounted, computed, watch, onBeforeMount, watchEffect} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import useAuth from '@/composables/useAuth'
import moment from 'moment';
import { useHead } from "@vueuse/head";
import DOMPurify from 'dompurify';


import { 
    IconCategory2, 
    IconColorSwatch, 
    IconCalendarStats, 
    IconBrandYoutube, 
    IconClipboardText, 
    IconNotes, 
    IconInfinity, 
    IconBook, 
    IconClockPlay, 
    IconChartBar, 
    IconSparkles, 
    IconVideo, 
    IconMessageQuestion, 
    IconTerminal2 
} from '@tabler/icons-vue';

// Using refs to hold course data and states
const isProgressFinished = ref(false);
const courseDetail = ref(null);
const courseInfo = ref(null);
const courseContents = ref(null);
const courseReviews = ref(null);
const enrollStatus = ref('Enroll For Free');
const enrollDisabled = ref(false);
const similarCourse = ref([]);
const courseContentOpen = ref(0);

const auth = useAuth();
const route = useRoute();
const router = useRouter();

const isExpanded = ref(false);

const toggleReadMore = () => {
  isExpanded.value = !isExpanded.value;
};

// Shuffle array function
function shuffleArray(array) {
    let shuffledArray = array.slice();
    for (let i = shuffledArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    return shuffledArray;
}

watch(() => route.params.CourseID, (newValue) => {
    fetchCourseDetail();
    fetchCourseInfo();
    fetchCourseContent();
    fetchCourseReviews();
    fetchSimilarCourse();
});

// onMounted lifecycle hook to initialize course and shuffled courses
onMounted(() => {
    fetchCourseInfo();
    fetchCourseContent();
    fetchCourseReviews();
    fetchSimilarCourse();

    fetchCourseDetail();
    
});

const fetchCourseDetail = async () => {
    try {
        const response = await axios.get(`/course/${route.params.CourseID}`)

        courseDetail.value = response?.data

        
        if (courseDetail.value.courses.isEnrolled) {
            // window.location.href = `/Internal/Course/Detail/${route.params.CourseID}`;
            enrollStatus.value = 'Enrolled';
            enrollDisabled.value = true;
        }

        isProgressFinished.value = true;
    } catch (error) {
        if (error?.response?.status == 404 || error?.response?.status == 301) {
            window.location.href = '/missing-page';
        }

        console.error('Error fetching course detail:', error)
    }
}

const fetchCourseInfo = async () => {
    try {
        const response = await axios.get(`/course/${route.params.CourseID}/detail`)

        courseInfo.value = response?.data
    } catch (error) {
        console.error('Error fetching course info:', error)
    }
}

const fetchCourseContent = async () => {
    try {
        const response = await axios.get(`/course/${route.params.CourseID}/contents`)

        courseContents.value = response?.data
    } catch (error) {
        console.error('Error fetching course content:', error)
    }
}

const fetchCourseReviews = async () => {
    try {
        const response = await axios.get(`/course/${route.params.CourseID}/reviews`)

        courseReviews.value = response?.data?.data
    } catch (error) {
        console.error('Error fetching course reviews:', error)
    }
}

const fetchSimilarCourse = async () => {
    try {
        const response = await axios.get(`/course/${route.params.ProgramID}/other-course`);
        similarCourse.value = response?.data;
    } catch (error) {
        console.error('Error fetching similar course:', error)
    }
}

const countAllLesson = () => {
    return courseContents.value.reduce((total, section) => {
        return total + section.sub_section.length;
    }, 0);
};

const getInitials = (name) => {
  const defaultInitial = "PP"
  if (!name) return defaultInitial;

  const parts = name.split(' ');
  const initials = parts.map(part => part.charAt(0).toUpperCase()).join(' ');
  return initials || defaultInitial;
};

const sanitizedDesc = (desc) => {
    return DOMPurify.sanitize(desc);
}

const avatarUrl = (name) => {
  return `https://ui-avatars.com/api/?name=${getInitials(name)}&size=128&background=random`;
};

const minuteToHour = (minute) => {
    const hour = Math.floor(minute / 60);
    const min = minute % 60;

    if (hour > 0) {
        if(min == 0){
            return `${hour}h`;
        }

        return `${hour}h ${min}m`;
    }

    return `${min}m`;
}

const courseImage = computed(() => {
  return courseDetail.value.courses.photo || defaultBanner;
});

// onEnroll function to show success message and navigate after enrolling
async function onEnroll() {
    if (!auth.get().authenticated) {
        sessionStorage.setItem('redirectAfterLogin', router.currentRoute.value.fullPath);
        router.push({ name: "AuthenticationSignInScreen" });

        return;
    }

    try {
        const response = await axios.post('/course/enroll/'+courseDetail.value.courses.id);

        enrollStatus.value = 'Enrolled';
        enrollDisabled.value = true;

        message.success('Success Enrolling Course!');

        setTimeout(() => {
            router.push('/Course/Learning/'+courseDetail.value.courses.slug);
        }, 1500);
    } catch (error) {
        if (error.response) {
            message.error(error?.response?.data?.message || 'An error occurred while enrolling');
            console.error('Error response:', error.response);

            return;
        }

        message.error(error.message);
        console.error('Error:', error.message);
        
    }

}
</script>
